import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import BuyerService from './components/BuyerService';
import SellerService from './components/SellerService';
import Client from './components/Client';
import Footer from './components/Footer';


function App() {
  return (
    <Router>
      <div className="App">
        <Navbar/>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/buyers" element={<BuyerService />} />
          <Route path="/sellers" element={<SellerService />} />
          <Route path ="/clients" element ={<Client />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;